import { render, staticRenderFns } from "./projectCenter.vue?vue&type=template&id=63865076"
import script from "./projectCenter.vue?vue&type=script&lang=js"
export * from "./projectCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports